import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import {pluralize} from 'BenchlingUtil';
import {FONT_FAMILY_PROXIMA} from 'styles/FontConstants';
import {GRAY_SEMIDARK} from 'ui-library/Colors';

interface ReplicateLimitLabelProps {
  replicateLimit: number;
}

export default function ReplicateLimitLabel({replicateLimit}: ReplicateLimitLabelProps): JSX.Element {
  return (
    <div className={css(styles.totalReplicates)}>
      Max {replicateLimit} total {pluralize(replicateLimit, 'replicate')}
    </div>
  );
}

const styles = StyleSheet.create({
  totalReplicates: {
    fontFamily: FONT_FAMILY_PROXIMA,
    fontSize: '12px',
    color: GRAY_SEMIDARK,
    textAlign: 'right',
    fontWeight: 400,
  },
});
